export enum PermissionConstants {
	PlaceOrder = "PlaceOrder",
	PlaceTestOrder = "PlaceTestOrder",
	IsAdmin = "IsAdmin",
	CanAddToBag = "CanAddToBag",
	CanOrderOnBehalf = "CanOrderOnBehalf",
	CanEditManualConfigurations = "CanEditManualConfigurations",
	CanUserFavorites = "CanUserFavorites",
	CanUseLoadData = "CanUseLoadData",
	CanOrderOnBehalfOfChainCustomer = "CanOrderOnBehalfOfChainCustomer",
	NewCustomerModuleEnabled = "NewCustomerModuleEnabled",
	PreciousModuleEnabled = "PreciousModuleEnabled",
	PriceModuleEnabled = "PriceModuleEnabled",
	PartsEnabled = "PartsEnabled",
	CanOrderAir = "CanOrderAir"
}
